const trimSlashEnd = (s = '') => s.replace(/\/+$/, '')
const ensureLeading = (s = '') => (s.startsWith('/') ? s : `/${s}`)
export function getFullImageUrl(dest: string, forMeta?: boolean): string {
  const path = ensureLeading(dest)

  const publicEngine = (typeof window !== 'undefined' ? (window as any).envs?.engineHost : '') || process.env.KK_HOST

  const publicKonakart =
    (typeof window !== 'undefined' ? (window as any).envs?.konakartServer : '') || process.env.KONAKART_HOST

  const origin = trimSlashEnd(forMeta ? publicKonakart : publicEngine)

  if (!origin) return `/images${path}`

  return `${origin}/images${path}`
}
